var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 600",
    id: "blogs-and-article",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "blogs and article"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 422.506,
    cy: 305.091,
    r: 206.878,
    fill: "#d9ebff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 46.323,
    height: 46.323,
    x: 429.611,
    y: 450.743,
    fill: "#a9c0ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 637.92,
    height: 9,
    x: 181.04,
    y: 511.466,
    fill: "#456ba3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6299e8",
    d: "M429.61065,494.06566V453.74285a3,3,0,0,0-3-3h-8.3999a3,3,0,0,0-3,3v54.72284a3,3,0,0,0,3,3h54.7229a3,3,0,0,0,3-3v-8.4a3,3,0,0,0-3-3h-40.323A3,3,0,0,1,429.61065,494.06566Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c2d5ff",
    d: "M459.9721,497.06566v14.4h43.323a3,3,0,0,0,3-3v-8.4a3,3,0,0,0-3-3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 41.595,
    height: 2,
    x: 202.927,
    y: 336.88,
    fill: "#a9c0ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 41.595,
    height: 2,
    x: 201.414,
    y: 324.611,
    fill: "#a9c0ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 41.595,
    height: 2,
    x: 204.366,
    y: 350.213,
    fill: "#a9c0ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 41.595,
    height: 2,
    x: 520.16,
    y: 175.588,
    fill: "#a9c0ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 41.595,
    height: 2,
    x: 518.648,
    y: 163.319,
    fill: "#a9c0ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 41.595,
    height: 2,
    x: 521.599,
    y: 188.92,
    fill: "#a9c0ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 266.4,
    height: 192.863,
    x: 301.303,
    y: 267.88,
    fill: "#6299e8",
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d76b8",
    d: "M561.70264,462.24316H307.30273a7.50851,7.50851,0,0,1-7.5-7.5V273.87988a7.50852,7.50852,0,0,1,7.5-7.5H561.70264a7.5082,7.5082,0,0,1,7.5,7.5V454.74316A7.5082,7.5082,0,0,1,561.70264,462.24316ZM307.30273,269.37988a4.50493,4.50493,0,0,0-4.5,4.5V454.74316a4.50492,4.50492,0,0,0,4.5,4.5H561.70264a4.50492,4.50492,0,0,0,4.5-4.5V273.87988a4.50493,4.50493,0,0,0-4.5-4.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 266.4,
    height: 192.863,
    x: 318.011,
    y: 267.88,
    fill: "#fff",
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 226.1,
    height: 153.276,
    x: 338.161,
    y: 287.673,
    fill: "#d9ebff",
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d76b8",
    d: "M578.41064,462.24316H324.01074a7.50851,7.50851,0,0,1-7.5-7.5V273.87988a7.50852,7.50852,0,0,1,7.5-7.5h254.3999a7.5082,7.5082,0,0,1,7.5,7.5V454.74316A7.50819,7.50819,0,0,1,578.41064,462.24316ZM324.01074,269.37988a4.50493,4.50493,0,0,0-4.5,4.5V454.74316a4.50492,4.50492,0,0,0,4.5,4.5h254.3999a4.50491,4.50491,0,0,0,4.5-4.5V273.87988a4.50492,4.50492,0,0,0-4.5-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a9c0ff",
    d: "M558.26055 287.67309H344.161a6 6 0 00-6 6v16.52178h226.0996V293.67309A6 6 0 00558.26055 287.67309zM338.161 421.80254v13.14691a6 6 0 006 6h214.0996a6 6 0 006-6V421.80254z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.2,
    height: 2,
    x: 354.811,
    y: 323.278,
    fill: "#456ba3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.2,
    height: 2,
    x: 354.811,
    y: 340.361,
    fill: "#456ba3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 193.12,
    height: 2,
    x: 354.811,
    y: 357.444,
    fill: "#456ba3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 193.12,
    height: 2,
    x: 354.811,
    y: 374.527,
    fill: "#456ba3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 193.12,
    height: 2,
    x: 354.811,
    y: 391.61,
    fill: "#456ba3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 193.12,
    height: 2,
    x: 354.811,
    y: 408.693,
    fill: "#456ba3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 157.416,
    height: 113.963,
    x: 461.663,
    y: 230.346,
    fill: "#6299e8",
    opacity: 0.28,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 157.416,
    height: 113.963,
    x: 476.783,
    y: 215.542,
    fill: "#fff",
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 157.416,
    height: 3,
    x: 476.783,
    y: 240.667,
    fill: "#a9c0ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d76b8",
    d: "M628.19873,331.00488H482.7832a7.5082,7.5082,0,0,1-7.5-7.5V221.542a7.5082,7.5082,0,0,1,7.5-7.5H628.19873a7.5082,7.5082,0,0,1,7.5,7.5V323.50488A7.5082,7.5082,0,0,1,628.19873,331.00488ZM482.7832,217.042a4.50493,4.50493,0,0,0-4.5,4.5V323.50488a4.50492,4.50492,0,0,0,4.5,4.5H628.19873a4.50491,4.50491,0,0,0,4.5-4.5V221.542a4.50492,4.50492,0,0,0-4.5-4.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 50.105,
    height: 50.105,
    x: 494.651,
    y: 250.494,
    fill: "#d9ebff",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60.48,
    height: 13.272,
    x: 551.891,
    y: 250.494,
    fill: "#a9c0ff",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 34.667,
    height: 7.608,
    x: 534.557,
    y: 311.287,
    fill: "#a9c0ff",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60.48,
    height: 13.272,
    x: 551.891,
    y: 268.911,
    fill: "#a9c0ff",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60.48,
    height: 13.272,
    x: 551.891,
    y: 287.328,
    fill: "#a9c0ff",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 157.416,
    height: 113.963,
    x: 239.303,
    y: 179.805,
    fill: "#6299e8",
    opacity: 0.28,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 157.416,
    height: 113.963,
    x: 216.58,
    y: 165.001,
    fill: "#fff",
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 157.416,
    height: 3,
    x: 216.58,
    y: 190.125,
    fill: "#a9c0ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d76b8",
    d: "M367.99561,280.46289H222.58008a7.5082,7.5082,0,0,1-7.5-7.5V171.001a7.5082,7.5082,0,0,1,7.5-7.5H367.99561a7.5082,7.5082,0,0,1,7.5,7.5V272.96289A7.5082,7.5082,0,0,1,367.99561,280.46289ZM222.58008,166.501a4.50491,4.50491,0,0,0-4.5,4.5V272.96289a4.50491,4.50491,0,0,0,4.5,4.5H367.99561a4.50492,4.50492,0,0,0,4.5-4.5V171.001a4.50492,4.50492,0,0,0-4.5-4.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 114.317,
    height: 13.272,
    x: 238.129,
    y: 202.953,
    fill: "#a9c0ff",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 114.317,
    height: 13.272,
    x: 238.129,
    y: 221.37,
    fill: "#a9c0ff",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 114.317,
    height: 3,
    x: 238.129,
    y: 243.667,
    fill: "#4d76b8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 114.317,
    height: 3,
    x: 238.129,
    y: 251.994,
    fill: "#4d76b8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 114.317,
    height: 3,
    x: 238.129,
    y: 260.322,
    fill: "#4d76b8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6299e8",
    d: "M606.12,510.29762h52.88921a13.15417,13.15417,0,0,1-12.788-10.07194l-17.1045-70.96549a13.15418,13.15418,0,0,0-12.788-10.072h-4.292a13.15417,13.15417,0,0,0-12.79681,16.19949L613.4895,495.2662a13.15417,13.15417,0,0,1-12.79681,16.19949h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d76b8",
    d: "M609.9746 419.07144h52.88921l.12353 0L680.23018 494.201a13.15417 13.15417 0 01-12.82084 16.09666h-8.40016a13.15417 13.15417 0 01-12.788-10.07194l-17.1045-70.96549a13.15418 13.15418 0 00-12.788-10.072zM582.76973 485.65136l5.33869 16.49015a13.15417 13.15417 0 0012.58425 9.32418h0A13.15417 13.15417 0 00613.4895 495.2662l-2.28809-9.61484z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6299e8",
    d: "M667.40934,510.29762A13.15417,13.15417,0,0,0,680.23018,494.201L651.64229,369.63943a13.15417,13.15417,0,0,1,12.82084-16.09666h5.12451l71.43026,16.09666L769.60579,494.201A13.15417,13.15417,0,0,1,756.785,510.29762H667.40934Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d76b8",
    d: "M753.83874,353.54277h5.12451a13.15416,13.15416,0,0,1,12.6396,9.511l5.96427,20.69236a13.15416,13.15416,0,0,0,12.6396,9.511H700.83111a13.15416,13.15416,0,0,1-12.6396-9.511l-5.96427-20.69236a13.15417,13.15417,0,0,0-12.6396-9.511Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#92b1ef",
    d: "M700.83111,393.25711h1.43873a13.15417,13.15417,0,0,0,12.78879-16.233l-2.166-8.99734h89.37561l2.166,8.99734a13.15416,13.15416,0,0,1-12.78879,16.233H700.83111Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 62.665,
    height: 3,
    x: 672.782,
    y: 413.484,
    fill: "#4d76b8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 62.665,
    height: 3,
    x: 677.083,
    y: 428.472,
    fill: "#4d76b8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 62.665,
    height: 3,
    x: 681.481,
    y: 443.596,
    fill: "#4d76b8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 62.665,
    height: 3,
    x: 685.879,
    y: 458.721,
    fill: "#4d76b8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 62.665,
    height: 3,
    x: 690.277,
    y: 473.845,
    fill: "#4d76b8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 62.665,
    height: 3,
    x: 694.675,
    y: 488.97,
    fill: "#4d76b8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.93,
    height: 3,
    x: 613.909,
    y: 441.333,
    fill: "#4d76b8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.931,
    height: 3,
    x: 616.031,
    y: 456.319,
    fill: "#4d76b8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.93,
    height: 3,
    x: 618.202,
    y: 471.444,
    fill: "#4d76b8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.93,
    height: 3,
    x: 620.373,
    y: 486.568,
    fill: "#4d76b8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a9c0ff",
    d: "M225.24731,407.45215c.66187,4.27661,1.05152,8.5498,1.34449,12.82153.17285,2.13623.24487,4.27124.366,6.407l.21192,6.40479q.13514,6.40393-.18872,12.802-.36,6.39733-.63867,12.79614l-1.0774,25.59473c-.4458,8.53052-.81909,17.062-1.32739,25.5918l-.5-.00659c-.29028-8.5398-.44507-17.07813-.67261-25.61719l-.42236-25.614q-.12414-6.40356-.31128-12.80835-.15711-6.40392.13867-12.80249l.37549-6.39746c.17578-2.13159.30225-4.26416.52979-6.39526.40234-4.26294.90112-8.52466,1.67211-12.783Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d76b8",
    d: "M248.47729,408.31665c.38965,1.04419.71705,2.09229,1.07789,3.13843l.97631,3.14477c.64405,2.09693,1.22974,4.19776,1.78785,6.3003.21289,4.26294.529,8.519.78833,12.779l1.63671,25.5542,1.63648,25.5542.81836,12.7771c-.6377,4.31714-1.24707,8.63281-2.17554,12.96875-1.47412-4.18213-2.6289-8.38452-3.81225-12.58545l-.81836-12.7771-1.63648-25.5542-1.63647-25.5542c-.28614-4.25806-.51587-8.51978-.84839-12.77515.2854-2.15649.59839-4.31469.96948-6.4768l.56738-3.24366C248.033,410.4834,248.22412,409.4021,248.47729,408.31665Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.489,
    height: 16.708,
    x: 225.809,
    y: 422.224,
    fill: "#a9c0ff",
    transform: "rotate(-80.272 261.054 430.578)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6299e8",
    d: "M227.43872 395.87817c.42529 1.03.78882 2.06617 1.18579 3.09912l1.08472 3.10914c.71606 2.07348 1.37427 4.15258 2.00464 6.23461.36035 4.25293.82348 8.49585 1.23022 12.74415l2.52 25.48217 2.52 25.48218 1.26 12.74121c-.48779 4.33692-.94751 8.6709-1.72559 13.03638-1.61767-4.12866-2.91748-8.28858-4.24536-12.4458l-1.26-12.74121-2.52-25.48218-2.52-25.48242c-.43335-4.24561-.81-8.49683-1.28979-12.738.21045-2.165.44849-4.333.74487-6.50659l.45459-3.26148C227.06958 398.05884 227.22314 396.97168 227.43872 395.87817zM243.26538 383.05688c.30835 1.07081.55444 2.14112.834 3.21167l.73266 3.21045c.4812 2.14014.9043 4.27954 1.29956 6.41871-.1145 4.2666-.126 8.53466-.19385 12.802l-.32739 25.60425-.32739 25.60449-.16382 12.80224c-.9668 4.25586-1.90527 8.512-3.16357 12.76392-1.14893-4.283-1.97828-8.56152-2.83594-12.84058l.16382-12.80224.32739-25.6045.32739-25.60449c.04126-4.26758.13916-8.53442.13379-12.80249.44971-2.12842.92725-4.25635 1.46314-6.38354l.81445-3.19068C242.65649 385.18311 242.92993 384.11963 243.26538 383.05688z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a9c0ff",
    d: "M235.81006,408.31982c.66186,4.27662,1.05151,8.54981,1.34473,12.82154.17285,2.13623.24462,4.27124.366,6.407l.21167,6.40478q.1355,6.40394-.18872,12.802-.36,6.39733-.63867,12.79614L235.82764,485.146c-.4458,8.53051-.81885,17.062-1.3274,25.59179l-.5-.00659c-.29-8.53979-.44482-17.07812-.67236-25.61719l-.42261-25.614q-.12378-6.40356-.311-12.80835-.15711-6.40393.13867-12.80249l.37549-6.39746c.17578-2.13159.30224-4.26416.52978-6.39526.4021-4.26294.90088-8.52466,1.67188-12.783Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6299e8",
    d: "M277.35986,407.449c.07544,1.11207.08985,2.21.13721,3.31543l.03833,3.29273c.01856,2.1936-.01953,4.37427-.085,6.54858-1.01245,4.14624-1.92456,8.31568-2.89185,12.47241l-5.72534,24.95826-5.72534,24.95825-2.86255,12.47925c-1.8435,3.95556-3.65918,7.91772-5.78662,11.80835-.219-4.429-.12646-8.78638-.06152-13.14991L257.26,481.65308l5.7251-24.95826,5.72534-24.95825c.94116-4.16284,1.93774-8.31274,2.8335-12.48584.88891-1.98535,1.80493-3.9646,2.77783-5.93066l1.46948-2.947C276.31567,409.39868,276.80737,408.417,277.35986,407.449Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#92b1ef",
    d: "M273.5073,511.46569H224.59384a2,2,0,0,1-1.995-1.85861L216.88233,438.947a2,2,0,0,1,1.995-2.14139h60.34648a2,2,0,0,1,1.995,2.14139l-5.71651,70.66006A2,2,0,0,1,273.5073,511.46569Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a9c0ff",
    points: "279.913 457.366 280.849 444.166 217.252 444.166 218.188 457.366 279.913 457.366"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M739.6203,240.189H682.26043a2.99984,2.99984,0,0,0-3,3v57.35986a2.99983,2.99983,0,0,0,3,3h36.94434l4.64551,6.91431a1,1,0,0,0,1.66015,0l4.64551-6.91431h9.46436a3,3,0,0,0,3-3V243.189A3,3,0,0,0,739.6203,240.189Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a9c0ff",
    d: "M721.20527,260.16587l-26.58918,8.24018a2.36495,2.36495,0,0,0-.1392,4.531l12.06023,4.04a.35468.35468,0,0,1,.2.19265l4.43673,11.51589a2.43264,2.43264,0,0,0,2.30636,1.5452h.06175a2.39394,2.39394,0,0,0,2.27383-1.652l8.45685-25.3988a2.35025,2.35025,0,0,0-.54437-2.36389,2.45627,2.45627,0,0,0-2.523-.65016Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d76b8",
    d: "M724.68018,312.40527a2.497,2.497,0,0,1-2.0752-1.10547l-4.19971-6.251h-36.145a4.50493,4.50493,0,0,1-4.5-4.5V243.18848a4.50492,4.50492,0,0,1,4.5-4.5h57.35987a4.50492,4.50492,0,0,1,4.5,4.5v57.36035a4.50493,4.50493,0,0,1-4.5,4.5h-8.665l-4.19971,6.251a2.49644,2.49644,0,0,1-2.07422,1.10547Zm-42.41993-70.71679a1.50164,1.50164,0,0,0-1.5,1.5v57.36035a1.50164,1.50164,0,0,0,1.5,1.5h37.74366l4.67627,6.96,4.67627-6.96h10.26367a1.50164,1.50164,0,0,0,1.5-1.5V243.18848a1.50164,1.50164,0,0,0-1.5-1.5Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.20b9f67a0040ff58d459177152272273.svg";
export { ForwardRef as ReactComponent };